import { DataGrid, type SelectionModel } from '@if/mui'
import { useCallback, useMemo, useState } from 'react'
import { useLoanCalendarAction } from '../LoanCalendarActionProvider'
import { useLoanCalendarSimulation } from '../LoanCalendarSimulationProvider'
import {
  useDetailColumnsVisibility,
  useLoanCalendarRowStyle,
  useLoanCalendarTableColumns,
} from './LoanCalendarTable-hook'
import LoanCalendarTableToolbar from './LoanCalendarTableToolbar'

const LoanCalendarTable = () => {
  const { currentSimulation } = useLoanCalendarSimulation()
  const { selectedPaymentIds, setSelectedPaymentIds } = useLoanCalendarAction()
  const [showMore, setShowMore] = useState(false)
  const columns = useLoanCalendarTableColumns()
  const visibilityModel = useDetailColumnsVisibility(showMore)
  const getRowStyle = useLoanCalendarRowStyle(currentSimulation.simulation)

  const selectionModel = useMemo<SelectionModel>(() => Array.from(selectedPaymentIds), [selectedPaymentIds])

  const handleSelectionModelChange = useCallback(
    (model: SelectionModel) => setSelectedPaymentIds(new Set(model as string[])),
    [setSelectedPaymentIds],
  )

  return (
    <DataGrid
      rows={currentSimulation.simulation.operationInformations}
      columns={columns}
      dataSourceIdKey="simulatedOperationId"
      paginated={false}
      cardBelow={false}
      dense
      alwaysActionMenu
      headerSticky
      selectable="multi"
      selectionModel={selectionModel}
      onSelectionModelChange={handleSelectionModelChange}
      visibilityModel={visibilityModel}
      getRowStyle={getRowStyle}
      toolbar={<LoanCalendarTableToolbar showMore={showMore} onShowMoreChange={setShowMore} />}
    />
  )
}

export default LoanCalendarTable
